module.exports = __webpack_public_path__ + "media/assets/images/location-f4ae0f72e4226df3ed8ed1f1241ba5c8.svg";